import { render, staticRenderFns } from "./ChangelogView.vue?vue&type=template&id=0f1f9356&scoped=true&"
import script from "./ChangelogView.vue?vue&type=script&lang=js&"
export * from "./ChangelogView.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogView.vue?vue&type=style&index=0&id=0f1f9356&scoped=true&lang=css&"
import style1 from "./ChangelogView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f9356",
  null
  
)

export default component.exports